import { getRawCookieValue } from '../cookie-consent/parse-consent-cookie';

/**
 * Cookie flag: '1' means this browser is internal QA/manual-testing traffic and must be
 * excluded from GA4, Ahrefs Web Analytics, and Algolia Insights. Set via a one-time visit
 * to any page with `?jc_qa=1` (`?jc_qa=0` clears it) — see server/vike-handler.ts for where
 * the query param is read and the cookie is set/cleared.
 */
export const INTERNAL_QA_EXCLUDE_COOKIE_NAME = 'jc_qa_exclude';

/** ~180 days, matching the cookie-consent cookie lifetime. */
export const INTERNAL_QA_EXCLUDE_MAX_AGE_SECONDS = 180 * 24 * 60 * 60;

/** Works for both a raw `Cookie` request header and `document.cookie`. */
export function isInternalQaExcludedFromCookieString(
  cookieHeaderOrDocumentCookie: string | null | undefined,
): boolean {
  return getRawCookieValue(cookieHeaderOrDocumentCookie ?? '', INTERNAL_QA_EXCLUDE_COOKIE_NAME) === '1';
}

/** True in the browser when this device previously opted in via `?jc_qa=1`. */
export function isInternalQaExcludedInBrowser(): boolean {
  if (typeof document === 'undefined') return false;
  return isInternalQaExcludedFromCookieString(document.cookie);
}

/** Builds a `Set-Cookie` header value to persist (`exclude=true`) or clear (`exclude=false`) the flag. */
export function buildInternalQaExcludeSetCookieHeader(exclude: boolean, secure: boolean): string {
  const segments = exclude
    ? [
        `${INTERNAL_QA_EXCLUDE_COOKIE_NAME}=1`,
        'Path=/',
        `Max-Age=${INTERNAL_QA_EXCLUDE_MAX_AGE_SECONDS}`,
        'SameSite=Lax',
      ]
    : [`${INTERNAL_QA_EXCLUDE_COOKIE_NAME}=`, 'Path=/', 'Max-Age=0', 'SameSite=Lax'];
  if (secure) segments.push('Secure');
  return segments.join('; ');
}
